import axios from 'axios'
const BASEURL = 'http://localhost:9599/'

const printer = {
    openOilGate: () => {
        const msg = {
            cmd: 'OpenOilPipe',
            data: {
                'prod_code': '666'
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '',
            method: 'post',
            params: encodeURIComponent(JSON.stringify(msg))
        }).then((resp) => {
            // console.log(resp)
        })
    },
    // 总成条码打印
    testPrint: (obj) => {
        return new Promise((resolve, reject) => {
            axios({
                // baseURL: BASEURL,
                url: BASEURL,
                method: 'post',
                data: encodeURIComponent(JSON.stringify(obj))
            }).then(resp => {
                // console.log(resp);
                resolve(resp)
            }).catch(err => {
                reject(err)
            })
        })
    },

    //打印清线合格证
    printCleanLog: cleanlog => {
        const printMsg = {
            cmd: cleanlog.is_extra ? 'dybox' : 'matbox',
            data: {
                boxBarcode: cleanlog.boxBarcodeNew,
                sapCode: cleanlog.matCode,
                prodName: cleanlog.matName,
                prodCode: cleanlog.matNumber,
                tuhao: cleanlog.matTuhao,
                customerMtCode: '',
                batchNo: cleanlog.matBatchNo,
                luhao: cleanlog.matFurnaceNo,
                glevel: cleanlog.matGlevel,
                count: cleanlog.clRestCount,
                checkPerson: cleanlog.clPersonName,
                date: dateFormat(cleanlog.createTime)
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/mes_printer/print/fpbox/' + cleanlog.boxBarcodeNew,
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },

    // 打印收货标签
    printWMSBarcode: printData => {
        if(printData.luhao != undefined && printData.luhao.length > 11){
            printData.luhao = printData.luhao.substring(0, 11);
        }
        if(printData.heatBatchNo != undefined && printData.heatBatchNo.length > 11){
            printData.heatBatchNo = printData.heatBatchNo.substring(0, 11);
        }
        const printMsg = {
            cmd: "WMS_DELI",
            data: {
                boxBarcode: printData.boxBarcode, // 箱号
                prodCode: printData.prodCode.trim(), // 物料编号
                prodName: printData.prodName.trim(), // 物料名称
                batchNo: printData.batchNo.trim(), // 批次号
                count: printData.count, // 数量
                checkPerson: printData.checkPerson, // 操作人
                date: printData.date, // 创建时间 
                poCode: printData.poCode, // 订单编号
                matSpecs: printData.matSpecs, // 规值
                whCode: printData.whCode, // 通道
                qrCode: printData.qrCode, // 箱号的格式
                supply: printData.supply, // 供应商 可以为空
                printTime: printData.printTime, // 当前打印时间
                isSta: printData.isSta, // 是否质检
                printTwo: printData.printTwo, // 打印张数
                location: printData.location, // 货位
                boxHeight: printData.boxHeight,
                titleType: printData.titleType,
                luhao: printData.luhao,
                heatBatchNo: printData.heatBatchNo,
                oldBoxbarcode: printData.oldBoxbarcode,
                remark:printData.remark,
                goodsTrackingNumber:printData.goodsTrackingNumber,
                materialGrade:printData.materialGrade,
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/',
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },

    // 打印间材收货标签
    printWMSIndirBarcode: printData => {
        const printMsg = {
            cmd: "WMS_INDIR",
            data: {
                boxBarcode: printData.boxBarcode, // 箱号
                prodCode: printData.prodCode, // 物料编号
                prodName: printData.prodName, // 物料名称
                batchNo: printData.batchNo, // 批次号
                count: printData.count, // 数量
                checkPerson: printData.checkPerson, // 操作人
                date: printData.date, // 创建时间 
                poCode: printData.poCode, // 订单编号
                matSpecs: printData.matSpecs, // 规值
                whCode: printData.whCode, // 通道
                qrCode: printData.qrCode, // 箱号的格式
                supply: printData.supply, // 供应商 可以为空
                printTime: printData.printTime, // 当前打印时间
                isSta: printData.isSta, // 是否质检
                printTwo: printData.printTwo, // 打印张数
                location: printData.location // 货位
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/',
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },

    // 打印收货标签 集合
    printWMSBarcodeList: printDatalist => {
        const printMsg = {
            cmd: "WMS_DELI_LIST",
            data: printDatalist,
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/',
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },

    //打印成品标签
    printWMSProductBarcode: printData => {
        const printMsg = {
            cmd: "WMS_PROD",
            data: {
                boxBarcode: printData.boxBarcode,
                prodCode: printData.prodCode,
                prodName: printData.prodName,
                batchNo: printData.batchNo,
                count: printData.count,
                checkPerson: printData.checkPerson,
                date: printData.date,
                poCode: printData.poCode,
                matSpecs: printData.matSpecs,
                whCode: printData.whCode,
                qrCode: printData.qrCode,
                supply: printData.supply,
                printTime: printData.printTime,
                packageCode: printData.packageCode,
                packCode: printData.packCode,
                com: printData.com,
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/',
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },

    //打印退料标签
    printWMSReturnBarcode: printData => {
        const printMsg = {
            cmd: "WMS_RETURN",
            data: {
                boxBarcode: printData.boxBarcode,
                prodCode: printData.prodCode,
                prodName: printData.prodName,
                batchNo: printData.batchNo,
                count: printData.count,
                checkPerson: printData.checkPerson,
                date: printData.date,
                poCode: printData.poCode,
                matSpecs: printData.matSpecs,
                whCode: printData.whCode,
                qrCode: printData.qrCode,
                supply: printData.supply,
                printTime: printData.printTime,
                remark: printData.remark,
                oldBoxbarcode: printData.oldBoxbarcode,
                orderNumber:printData.orderNumber,
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/',
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },

    //打印供应商标签
    printWMSSupplyBarcode: printData => {
        const printMsg = {
            cmd: "WMS_SUPPLY",
            data: {
                boxBarcode: printData.boxBarcode,
                prodName: printData.prodName,
                prodCode: printData.prodCode,
                batchNo: printData.batchNo,
                count: printData.count,
                checkPerson: printData.checkPerson,
                checkNumber: printData.checkNumber,
                date: printData.date,
                poCode: printData.poCode,
                matSpecs: printData.matSpecs,
                whCode: printData.whCode,
                qrCode: printData.qrCode,
                supply: printData.supply,
                printTime: printData.printTime,
                printTwo: printData.printTwo,
                steel_code: printData.steel_code,
                draw_code: printData.draw_code,
                rolled_steel_code: printData.rolled_steel_code,
                forge_code: printData.forge_code,
                forge_supplier_code: printData.forge_supplier_code,
                heat_treatment_code: printData.heat_treatment_code,
                surface_code: printData.surface_code,
                supplier_retrospect_code: printData.supplier_retrospect_code,
                printCount: printData.printCount,
                supplyName: printData.supplyName,
                fcAddress: printData.fcAddress,
                fcName: printData.fcName
            },
            timestamp: new Date().getTime()
        }
        axios({
            baseURL: BASEURL,
            url: '/',
            method: 'post',
            data: encodeURIComponent(JSON.stringify(printMsg))
        }).then(resp => {
            // console.log(resp)
        })
    },



    // 获取打印机Mac地址，虚拟MAc地址
    getPrinterMac: () => {
        if (localStorage.getItem('PrinterMac')) return localStorage.getItem('PrinterMac')
        else {
            let mac = ''
            mac = printer.guidRFID()
            localStorage.setItem('PrinterMac', mac)
            return mac
        }
    },

    guidRFID: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
        })
    }
}

export default printer
